import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import inView from 'in-view'
import { rafThrottle } from 'utils'
import { LayeredBackgroundImage } from 'containers'
import { withRadium, DetectCompact } from 'higher-order-components'

/** AutoPlay Layered Background Image Component */
class LayeredBackgroundImageAutoplay extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 0
    }
    this.itemLength = this.props.imageSrcArray.length
    this.inViewHandler = rafThrottle(this.inViewHandler)
  }
  componentDidMount() {
    const { interval } = this.props
    this.slideshow = ReactDOM.findDOMNode(this)
    interval && window.addEventListener('scroll', this.inViewHandler)
    interval && this.inViewHandler()
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.inViewHandler)
    this.inViewHandler.cancel()
  }
  inViewHandler = () => {
    if (inView.is(this.slideshow)) {
      if (!this.state.playing) {
        this.setState({ active: 0, playing: true }, () => {
          this.timerEvent(this.props.interval)
        })
      }
    } else {
      this.clearTimerInterval()
    }
  }
  timerEvent = (interval) => {
    this.interval = setInterval(() => {
      const { active } = this.state
      if (!this.props.loop && active >= this.itemLength - 1) {
        this.clearTimerInterval()
      } else {
        this.handleChange(active + 1)
      }
    }, interval)
  }
  clearTimerInterval = () => {
    this.setState({ playing: false })
    clearInterval(this.interval)
  }
  handleChange = (index) => {
    if (this.props.loop) {
      index = index < 0 ? this.itemLength - 1 : index
      index = index > this.itemLength - 1 ? 0 : index
    } else {
      index = index < 0 ? 0 : index
      index = index > this.itemLength - 1 ? this.itemLength - 1 : index
    }
    this.setState({ active: index })
  }

  /**
   * @param {Number} [interval] - If set, slides will change automatically with the specified interval.
   * @param {Boolean} [loop=true] - If the slide updates past the final slide, it will loop back to the first (and vise versa).
   * @param {String} [disclaimer] - Dislaimer text as xmlString
   * @param {Array|SlideshowItem} imageSrcArray - Array of imageurls.
   * @returns {ReactElement} React Component
   */
  render() {
    const { active } = this.state
    const activeImage = this.props.imageSrcArray[active]
    return (
      <div
        style={{
          position: this.props.compact ? 'relative' : 'absolute',
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          boxSizing: 'border-box',
          overflow: 'hidden',
          zIndex: '-1',
          top: 0,
          left: 0
        }}>
        {activeImage && (
          <LayeredBackgroundImage
            fill
            backgroundSize={this.props.backgroundSize}
            transition={activeImage.transition}
            imageSrc={activeImage.imageSrc} />
        )}
      </div>
    )
  }
}

LayeredBackgroundImageAutoplay.propTypes = {
  interval: PropTypes.number,
  backgroundSize: PropTypes.oneOf(['contain', 'cover']),
  loop: PropTypes.bool,
  imageSrcArray: PropTypes.array
}

LayeredBackgroundImageAutoplay.defaultProps = {
  loop: true,
  interval: 500
}

export default DetectCompact({ threshold: 820 })(LayeredBackgroundImageAutoplay)



// WEBPACK FOOTER //
// ./src/containers/layered-background-image-autoplay/index.jsx